<template>
  <SectionCard01CarouselResource02
    v-if="contextData"
    :title="contextData.title"
    :description="contextData.description"
    :items="contextItems"
    :theme="theme"
  />
</template>

<script setup lang="ts">
  import type { ISuiteProps } from '@/components/Shared/Suite/type.ts';

  interface IItem {
    name: string;
    description: string;
    link: string;
    thumbnail: string;
    wistiaCode?: string;
    trackingCode?: string;
  }

  interface IResourcesSplitData {
    title: string;
    description?: string;
    items: IItem[];
  }

  interface IResourcesSplit {
    component: 'resources-split';
    meta: {
      navigable?: string;
    };
    data: IResourcesSplitData;
  }

  type IProps = ISuiteProps<IResourcesSplit>;

  const props = defineProps<IProps>();

  const solutionsStore = useSolutionsStore();
  const { themeStyle } = storeToRefs(solutionsStore);

  const { provideFormatUrl } = useFormatUrl();
  const { provideSuiteThumbnailUrl } = useImagePath(props.urlConnector);

  const contextData = computed((): IResourcesSplitData => props.suiteData.data);

  const contextItems = computed((): IItem[] =>
    contextData.value.items.map((item) => ({
      ...item,
      thumbnail: provideSuiteThumbnailUrl(item.thumbnail),
      link: provideFormatUrl(item.link),
    }))
  );

  const theme = computed((): TTheme => {
    switch (themeStyle.value) {
      case 'sustainable':
        return 'green';
      case 'connected':
        return 'cyan';
      case 'ai':
        return 'purple';
      case 'operations':
        return 'yellow';
      default:
        return 'blue';
    }
  });

  export type { IItem, IResourcesSplit, IResourcesSplitData };
</script>
